import { call, takeLatest, select } from 'redux-saga/effects';
import { getTroubleshootingConfigRequest } from './api';
import { FETCH_TROUBLESHOOTING_CONFIG } from '../../types';
import { validateConfig } from './utils';
import { selectFirstName, selectLastName, selectUserEmail } from '../Contact/selectors';

export function* getTroubleshootingConfigRequestSaga({
  payload: { troubleshootingGuide, locale, onSuccess, onError },
}) {
  const firstName = yield select(selectFirstName);
  const lastName = yield select(selectLastName);
  const email = yield select(selectUserEmail);
  const query = new URLSearchParams(window.location.search);
  const installationId = query.get('installationId');

  try {
    const contactDetails = JSON.stringify({
      firstName,
      lastName,
      email,
    });

    const { data: response } = yield call(
      getTroubleshootingConfigRequest,
      troubleshootingGuide,
      locale,
      { contactDetails, installationId }
    );

    if (!validateConfig(response)) {
      throw new Error(`invalidTroubleshootingGuide`);
    }

    onSuccess(response.data);
  } catch (e) {
    onError(true);
  }
}

const troubleshootingGuideSagas = [
  takeLatest(FETCH_TROUBLESHOOTING_CONFIG, getTroubleshootingConfigRequestSaga),
];

export default troubleshootingGuideSagas;
